import { string } from "yup/lib/locale"

export const ENTRY_ACTIONS = {
    CONTINUE: 'CONTINUE',
    VIEW_PDF: 'VIEW_PDF',
    DOWNLOAD_PDF: 'DOWNLOAD_PDF',
    PRINT_PDF: 'PRINT_PDF',
    REUSE_ENTRY: 'REUSE_ENTRY',
    DELETE: 'DELETE',
    PRINT_PROJECT_PROFILE:'PRINT_PROJECT_PROFILE',
    DOWNLOAD_PROJECT_PROFILE:'DOWNLOAD_PROJECT_PROFILE',
    SUBMIT_SCROE:'SUBMIT_SCROE',
    ENTRY_ANSWER:'ENTRY_ANSWER',
    ENTRY_SCORES: 'ENTRY_SCORES',

}

export const ROLES:any={
    USER:'User',
    JUDGE:'Judge',
    JUDGECHAIRERSON:'JudgeChairPerson',
    PARTNER:'Partner'
}
export const mapRole=(role:string)=>{
    const roles:any={
        'User':'User',
       'Judge':'Judge',
      'Judge Chairperson':'JudgeChairPerson',
       'Partner':'Partner'
    }
    
    return roles[role]?roles[role]:role

}
